module.exports = __webpack_public_path__ + "img/logonewfull.dcd2437b.svg";